const publishNewRelicPageAction = ({ actionName = '', actionObject = null }) => {
  if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
    LIFE_CYCLE_EVENT_BUS.trigger('cart.cartPageAction', { actionName, actionObject });
  }
};

export const paypalSmartButtonClickNewRelic = (ffm, fromPage, hasSavedPaypal, isUpdatePaypal = false, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonClick',
    actionObject: {
      fulfillment: ffm,
      hasSavedPaypal,
      isUpdatePaypal,
      page: fromPage,
      payInFour
    }
  });
};

export const paypalSmartButtonSuccessNewRelic = (fromPage, cartId, payInFour, paypalData) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonSuccess',
    actionObject: {
      cartId,
      page: fromPage,
      payInFour,
      paypalData
    }
  });
};

export const paypalSmartButtonCancelNewRelic = (fromPage, cartId, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonCancel',
    actionObject: {
      cartId,
      page: fromPage,
      payInFour
    }
  });
};

const MAX_ERROR_LENGTH = 1000;

// Keep only the path and :line:col of each URL. Query strings and fragments can carry customer data,
// and the PayPal SDK's alone make each stack frame ~230 characters long. A URL runs to the next whitespace
// or " < > (browsers always percent-encode those, but leave ( ) and ' raw), so its closing punctuation and
// :line:col are peeled off and put back. The bounded scheme keeps long messages linear.
const stripUrlQueries = (text) => text.replace(/[a-z][\w+.-]{0,30}:\/\/[^\s"<>]+/gi, (url) => {
  let end = url.length;
  while (end > 0 && ')]},;.\''.includes(url[end - 1])) end -= 1;
  end -= url.slice(0, end).match(/(?::\d+){0,2}$/)[0].length;
  return url.slice(0, end).split(/[?#]/)[0] + url.slice(end);
});

// JSON.stringify drops an Error's message and stack (they are not enumerable), so read the message directly.
// A plain object without a message is still stringified so its fields stay readable.
const describeError = (error) => {
  if (error?.message || error instanceof Error || typeof error !== 'object') {
    return String(error?.message || error);
  }
  try {
    return JSON.stringify(error) ?? String(error);
  } catch (stringifyError) {
    return String(error);
  }
};

export const paypalSmartButtonErrorNewRelic = (error, fromPage, payInFour, cartId) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonError',
    actionObject: {
      cartId,
      error: stripUrlQueries(describeError(error)).slice(0, MAX_ERROR_LENGTH),
      errorName: error?.name,
      errorStack: error?.stack && stripUrlQueries(error.stack).slice(0, MAX_ERROR_LENGTH),
      page: fromPage,
      payInFour
    }
  });
};

export const paypalSmartButtonAddToCartFailNewRelic = (fromPage, payInFour, errorObj) => {
  const { description, errorCode } = errorObj || {};
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonAddToCartFail',
    actionObject: {
      error: description || 'Unknown error',
      errorCode: errorCode || '',
      page: fromPage,
      payInFour
    }
  });
};

export const paypalSmartButtonInitFailNewRelic = (errorCode, description, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonInitFail',
    actionObject: {
      error: description || 'Unknown error',
      errorCode: errorCode || '',
      payInFour
    }
  });
};

export const savedPaypalButtonClickNewRelic = (isAuthUser, isValidCart, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'savedPaypalButtonClick',
    actionObject: {
      isAuthUser,
      isValidCart,
      payInFour
    }
  });
};

export const paypalMessageClickNewRelic = (fromPage) => {
  publishNewRelicPageAction({
    actionName: 'paypalMessageClick',
    actionObject: {
      page: fromPage,
    }
  });
};

export const paypalMissingData = (fromPage, missingProps, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'paypalMissingData',
    actionObject: {
      missingProps,
      page: fromPage,
      payInFour,
    }
  });
};